import moment from 'moment'
import { isDealer } from '../services/AccountService'
import { MaintenanceOrder } from '../types/service.types'
import { getComp } from '../utils/utils/DI'
import { RequestType } from '../views/SingleRequestPage/types/Request.type'
import { formatAddress, formatName, formatPhoneNumber } from './ordersUtiles'

export const getCorrectServiceTableValue = (
  key: keyof MaintenanceOrder,
  el: MaintenanceOrder,
) => {
  const dealersStore = getComp('DealersStore')
  let value = el[key]

  if (key === 'assignedDealerId') {
    if (isDealer()) {
      const user = getComp('UserInfoStore')?.info
      value = user?.id === el[key] ? user?.displayName : '-'
    } else value = dealersStore.getDealerName(el[key])
  }

  if (key === 'authorId') {
    if (isDealer()) {
      const user = getComp('UserInfoStore')?.info
      value = user?.id === el[key] ? user?.displayName : '-'
    } else value = dealersStore.getDealerName(el[key])
  }

  if (['dateOfMaintenance', 'created'].includes(key))
    value = value ? moment(value as string).format('DD.MM.YYYY') : '-'
  if (key === 'locality') value = formatAddress(el, false)

  if (key === 'name') value = formatName(el)
  if (key === 'phoneNumber') value = formatPhoneNumber(el.phoneNumber)

  return key === 'id' ? String(value).padStart(6, '0') : value
}

export const getBackgroundColor = (order: MaintenanceOrder | RequestType) => {
  switch (order.dataCheckingStatus) {
    case 1:
      return 'rgba(22,176,37,0.3)'
    case 2:
      return 'rgba(224,23,23,0.25)'
    case 3:
      return 'rgba(224,96,23,0.3)'

    default:
      return undefined
  }
}
